{
  "progress": {
    "done": "Concluído",
    "step": "Etapa {{current}} de {{total}}"
  },
  "intro": {
    "tag": "Sua opinião importa",
    "defaultDescription": "Responda algumas perguntas rápidas e nos ajude a melhorar sua experiência.",
    "questions_one": "{{count}} pergunta",
    "questions_zero": "{{count}} perguntas",
    "questions_other": "{{count}} perguntas",
    "duration": "~{{minutes}} min",
    "start": "Começar agora",
    "later": "Responder depois"
  },
  "navigation": {
    "previous": "Anterior",
    "submit": "Enviar resposta",
    "next": "Próxima"
  },
  "done": {
    "title": "Obrigado!",
    "description": "Sua resposta foi enviada com sucesso",
    "xpEarned": "+{{xp}} XP ganhos"
  },
  "input": {
    "selectPlaceholder": "Selecione",
    "npsLow": "Nada provável",
    "npsHigh": "Muito provável"
  },
  "toast": {
    "created": "Pesquisa criada!",
    "createError": "Erro ao criar pesquisa",
    "updated": "Pesquisa atualizada!",
    "updateError": "Erro ao atualizar pesquisa",
    "deleted": "Pesquisa excluída",
    "deleteError": "Erro ao excluir",
    "duplicated": "Pesquisa duplicada!",
    "duplicateError": "Erro ao duplicar",
    "responseSent": "Resposta enviada com sucesso!",
    "responseError": "Erro ao enviar resposta"
  }
}
